/**
 * @author yueheqin
 * @date 2018/12/13
 * @project kaoshizhongxin-pc
 * @description 登录
 */
import request from '../utils/request'
import { API_URL, API_LOGOUT_URL } from '../config'

const login = {
  login: API_URL + 'v1/user/login',
  oauthqqlogin: API_URL + 'v1/user/oauth-login',
  oauthbind: API_URL + 'v1/user/oauth-bind',
  sendsms: API_URL + 'v1/user/send-sms',
  register: API_URL + 'v1/user/register',
  checkName: API_URL + 'v1/user/check-name',
  checkCode: API_URL + 'v1/user/check-code',
  resetPwd: API_URL + 'v1/user/reset-password',
  logout: API_LOGOUT_URL + 'api/web/logout' // 退出登录，调用单点登录站点接口
}

// 登录
export const loginApi = (data, config) => request.post(login.login, data, config)

// 获取注册验证码
export const getCodeApi = (data, config) => request.post(login.sendsms, data, config)

// 注册
export const userRegisterApi = (data, config) => request.post(login.register, data, config)

// 找回密码确认账号
export const checkNameApi = (data, config) => request.post(login.checkName, data, config)

// 找回密码身份验证
export const checkCodeApi = (data, config) => request.post(login.checkCode, data, config)

// 修改密码
export const editPwd = (data, config) => request.post(login.resetPwd, data, config)

// qq登录
export const oauthQQLoginApi = (openID, config) => request.post(login.oauthqqlogin, {openID}, config)

// 绑定手机号
export const oauthBindPhoneApi = (data, config) => request.post(login.oauthbind, data, config)

export const logoutApi = (data, config) => request.post(login.logout, data, config)
